import React from "react";

const ContactForm = () => {
  return (
    <section className="form-container fade-in">
      <h1>Thank you for reaching me.</h1>
      <form action="https://formsubmit.co/zenestekin@gmail.com" method="POST">
        <div className="form">
          <div className="form-group">
            <label htmlFor="name">Name</label>
            <input type="text" name="name" id="name" required />
            <input type="hidden" name="_captcha" value="false" />
            <input
              type="hidden"
              name="_next"
              value="https://enestekin.netlify.app/thankyou.html"
            />
            <input type="hidden" name="_subject" value="New Message!" />
          </div>
          <div className="form-group">
            <label for="email">Email</label>
            <input type="email" name="email" id="email" required />
          </div>
        </div>
        <div className="textarea">
          <label htmlFor="textarea">Type Your Message</label>
          <textarea
            name="textarea"
            id="textarea"
            cols="30"
            rows="10"
          ></textarea>
        </div>
        <button type="submit" name="submit" className="form__btn">
          Submit
        </button>
      </form>
    </section>
  );
};

export default ContactForm;
